import React from "react"
import { Navigate } from "react-router-dom"
import { useAuth } from "./AuthContext"

// Gates dashboard pages behind a valid SSH link. Users whose account has not
// linked (and connection-tested) an SSH login can only reach Hut & Heroes — and
// the SSH tab in Settings to link one. Renders inside <ProtectedRoute>, so a
// user is always present here; only the ssh_linked flag decides access.
export default function SshGate({ children }) {
  const { user } = useAuth()
  if (!user?.ssh_linked) return <Navigate to="/hut" replace />
  return children
}
